import { Form, Spinner } from 'react-bootstrap';
import classNames from 'classnames';

import PagesHeader from '../../../../../components/base/PagesHeader';

import styles from '../../../../../assets/scss/6-pages/superAdmin/pension-policy/SpecialCondition.module.scss';
import {
  AbsentTransactionCauseCode,
  AbsentTransactionCauseCodeWithMeta,
  PolicyAbsentTransactionLeave,
} from '../../types';
import { useEffect, useRef, useState } from 'react';
import useLocale from '../../../../../hooks/useLocale';
import { LocaleCode } from '../../../../../types/locale';
import useContext from '../../PensionPolicyContext/useContext';
import { getAbsentTransactionCodes } from '../../../../../api/service/superAdmin/pension-policies/service';

const OtherAbsenceLeaveViewer = () => {
  const { localize, lang } = useLocale();
  const { selectedPolicyDetails } = useContext();

  const [transactionCodes, setTransactionCodes] = useState<AbsentTransactionCauseCodeWithMeta[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const hasPatchedPolicyDetails = useRef(false);

  const fetchAbsentTransactionCodeList = async (defaultOptions: PolicyAbsentTransactionLeave[] = []) => {
    try {
      setIsLoading(true);
      const transactionCodes = (await getAbsentTransactionCodes()) as AbsentTransactionCauseCode[];

      const transactionCodesData = transactionCodes
        .filter((item) => defaultOptions.some((option) => option.causeCode?.id === item.id))
        .map((item) => {
          const selectedDefaultOption = defaultOptions.find((option) => option.causeCode?.id === item.id);
          return updateAbsentTransactionCodeData(item, {
            checked: selectedDefaultOption?.isChecked || false,
            includedIn: {
              premium: selectedDefaultOption?.isPremiumCalculation || false,
              salary: selectedDefaultOption?.isSalaryChange || false,
              insurance: selectedDefaultOption?.isInsurances || false,
            },
          });
        });

      setTransactionCodes(transactionCodesData);
    } catch (error) {
      console.error('Error fetching absent transaction codes:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateAbsentTransactionCodeData = (
    item: AbsentTransactionCauseCode,
    optionChecked: Pick<AbsentTransactionCauseCodeWithMeta['_internal'], 'checked' | 'includedIn'>,
  ): AbsentTransactionCauseCodeWithMeta => {
    return {
      ...item,
      _internal: {
        title: lang === LocaleCode.EN ? item.english : item.swedish || item.english || '',
        checked: optionChecked.checked,
        includedIn: optionChecked.includedIn,
      },
    };
  };

  useEffect(() => {
    fetchAbsentTransactionCodeList();
  }, []);

  useEffect(() => {
    setTransactionCodes((prev) => {
      return prev.map((item) =>
        updateAbsentTransactionCodeData(item, {
          checked: item._internal.checked,
          includedIn: item._internal.includedIn,
        }),
      );
    });
  }, [lang]);

  useEffect(() => {
    if (selectedPolicyDetails) {
      hasPatchedPolicyDetails.current = true;

      if (selectedPolicyDetails.policySettings?.specialConditions?.otherLeave) {
        fetchAbsentTransactionCodeList(selectedPolicyDetails.policySettings.specialConditions.otherLeave);
      }
    }
  }, [selectedPolicyDetails]);

  if (transactionCodes.length === 0 && !isLoading) {
    return <></>;
  }

  return (
    <div className={classNames('mb-3 parental-check-group', styles.sp_cond_group)}>
      <PagesHeader
        pageTitle={localize('PENSION_POLICY.other_leave')}
        translate={false}
        subText={localize('PENSION_POLICY.new_job_leave')}
        subTextPosition="bottom"
      />
      {/* <div className="d-flex align-items-end dark-content-section">
        <Container fluid>
          <Row className="w-100">
            <Col>
              <Form.Group className="pe-0">
                <Form.Check
                  inline
                  type="checkbox"
                  label={`${localize('PENSION_POLICY.policy_valid_parental_leave')}`}
                  id="otherLeaveisChecked"
                  className="fs-name mb-1"
                  disabled
                  name="otherLeaveisChecked"
                  defaultChecked={otherLeave.isChecked}
                />
              </Form.Group>
            </Col>

            <Col sm="7">
              {isPolicyPartIncluded(PolicyLeaveCategory.OTHER, true) && (
                <p className="fs-name">{localize('PENSION_POLICY.policy_parts_included')}</p>
              )}

              {isPolicyPartIncluded(PolicyLeaveCategory.OTHER) && (
                <div className={styles.sp_cond_parts}>
                  {otherLeave.isPremiumCalculation && (
                    <div className={styles.sp_cond_parts__type}>
                      <Form.Group className="pe-0">
                        <Form.Check
                          inline
                          type="checkbox"
                          label={localize('PENSION_POLICY.premium_calculation')}
                          id="otherLeaveisPremiumCalculation"
                          className={classNames('fs-name mb-1', styles.include_part)}
                          disabled
                          name="otherLeaveisPremiumCalculation"
                          defaultChecked={otherLeave.isPremiumCalculation}
                        />
                      </Form.Group>
                    </div>
                  )}

                  {otherLeave.isSalaryChange && (
                    <div className={styles.sp_cond_parts__type}>
                      <Form.Group className="pe-0">
                        <Form.Check
                          inline
                          type="checkbox"
                          label={localize('PENSION_POLICY.applicable_salary_change')}
                          id="otherLeaveisSalaryChange"
                          className={classNames('fs-name mb-1', styles.include_part)}
                          disabled
                          name="otherLeaveisSalaryChange"
                          defaultChecked={otherLeave.isSalaryChange}
                        />
                      </Form.Group>
                    </div>
                  )}

                  {otherLeave.isInsurances && (
                    <div className={styles.sp_cond_parts__type}>
                      <Form.Group className="pe-0">
                        <Form.Check
                          inline
                          type="checkbox"
                          label={localize('insurances')}
                          id="otherLeaveisInsurances"
                          className={classNames('fs-name mb-1', styles.include_part)}
                          disabled
                          name="otherLeaveisInsurances"
                          defaultChecked={otherLeave.isInsurances}
                        />
                      </Form.Group>
                    </div>
                  )}
                </div>
              )}

              {otherLeave.maximumLength && (
                <div className={styles.sp_other_opt}>
                  <Form.Group className={classNames(styles.child_leave_opt)}>
                    <Form.Label className="fs-name">
                      {localize('PENSION_POLICY.max_length')} <span className="font-weight-400">({localize('days')})</span>
                    </Form.Label>
                    <Form.Control disabled name="otherLeaveMaximumOpt" value={otherLeave.maximumLength} />
                  </Form.Group>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div> */}

      <div className="d-flex align-items-end dark-content-section">
        <div className="table-responsive react-bootstrap-table">
          <table className="table salary-types-table">
            <thead className="header-wrapper">
              <tr className="correcto-table-header">
                <th style={{ maxWidth: 400, width: 400 }}>{localize('PENSION_POLICY.absence_type')}</th>
                <th style={{ maxWidth: 130, width: 130, minWidth: 130 }}>
                  <div className={styles.sp_cond_header_cell}>
                    <span>{localize('GLOBAL.included_in')}</span>
                    <span>{localize('PENSION_POLICY.premium_calculation')}</span>
                  </div>
                </th>
                <th style={{ maxWidth: 130, width: 130, minWidth: 130 }}>
                  <div className={styles.sp_cond_header_cell}>
                    <span>{localize('GLOBAL.included_in')}</span>
                    <span>{localize('PENSION_POLICY.salary_change')}</span>
                  </div>
                </th>
                <th style={{ maxWidth: 130, width: 130, minWidth: 130 }}>
                  <div className={styles.sp_cond_header_cell}>
                    <span>{localize('GLOBAL.included_in')}</span>
                    <span>{localize('PENSION_POLICY.insurances')}</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {!isLoading && transactionCodes.length === 0 && (
                <tr>
                  <td colSpan={4}>{localize('GLOBAL.no_data_available')}</td>
                </tr>
              )}
              {isLoading && (
                <tr>
                  <td colSpan={4}>
                    <Spinner animation="border" role="status" style={{ width: 24, height: 24 }} />
                  </td>
                </tr>
              )}
              {transactionCodes.map((item) => {
                return (
                  <tr key={item.id}>
                    <td style={{ maxWidth: 400, width: 400, minWidth: 400 }}>
                      <Form.Group className="pe-0">
                        <Form.Check
                          inline
                          type="checkbox"
                          label={item._internal.title}
                          id={`causename-${item.id}`}
                          name={`causename-${item.id}`}
                          className={classNames('fs-name mb-1', 'form-chk-active-label')}
                          disabled
                          defaultChecked={item._internal.checked}
                          checked={item._internal.checked}
                        />
                      </Form.Group>
                    </td>
                    <td style={{ maxWidth: 130, width: 130, minWidth: 130 }}>
                      <Form.Group className="pe-0">
                        <Form.Check
                          inline
                          type="checkbox"
                          label=""
                          id={`premium-${item.id}`}
                          name={`premium-${item.id}`}
                          className="fs-name mb-1"
                          disabled
                          defaultChecked={item._internal.includedIn.premium}
                          checked={item._internal.includedIn.premium}
                        />
                      </Form.Group>
                    </td>
                    <td style={{ maxWidth: 130, width: 130, minWidth: 130 }}>
                      <Form.Group className="pe-0">
                        <Form.Check
                          inline
                          type="checkbox"
                          label=""
                          id={`salary-${item.id}`}
                          name={`salary-${item.id}`}
                          className="fs-name mb-1"
                          disabled
                          defaultChecked={item._internal.includedIn.salary}
                          checked={item._internal.includedIn.salary}
                        />
                      </Form.Group>
                    </td>
                    <td style={{ maxWidth: 130, width: 130, minWidth: 130 }}>
                      <Form.Group className="pe-0">
                        <Form.Check
                          inline
                          type="checkbox"
                          label=""
                          id={`insurance-${item.id}`}
                          name={`insurance-${item.id}`}
                          className="fs-name mb-1"
                          disabled
                          defaultChecked={item._internal.includedIn.insurance}
                          checked={item._internal.includedIn.insurance}
                        />
                      </Form.Group>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OtherAbsenceLeaveViewer;
